// Module
var code = "<div class=\"h-100 w-100 flex-container-column gap-3\">\n    <cjs-button ref=\"addProduct\" class=\"align-self-end\"></cjs-button>\n    <cjs-smart-table ref=\"products\"></cjs-smart-table>\n</div>";
// Exports
module.exports = code;